import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Select from 'react-select';
import { Form, FormGroup, Label } from 'reactstrap';
import { Button, InputField } from 'src/components';
import { setFromErrors } from 'src/helpers';
import { useCreateTargetSetupMutation, useGetEntryMasterWiseTargetQuery } from 'src/rtk/features/setup/logBookEntrySetupMaster/logBookEntrySetupMasterApi';
import { useGetLookupDataQuery } from 'src/rtk/features/setup/lookup/lookupDataApi';
import * as Yup from 'yup';
import loader from '../../../assets/images/loader.gif';
import CompetencyGroupTargetsList from './CompetencyGroupTargetsList';

const initialValues: TargetSetup = {
    id: '',
    logbook_entry_setup_master_id: '',
    year: '',
    min_value: '',
};

const AddCompetencyGroupTargets = (props: any) => {
    const { logbookEntrySetupMasterId, logbookGroup, logbookEntryFieldList, setSearch, submitStatus, readOnly } = props;

    const [selectedCompetenceTitle, setSelectedCompetenceTitle] = useState<any>('');
    const [selectedCompetenceLevel, setSelectedCompetenceLevel] = useState<any>([]);
    const [selectedSlot, setSelectedSlot] = useState<any>([]);
    const [competenceLevelTypeOptions, setCompetenceLevelTypeOptions] = useState<SelectOption[]>([]);
    
    // New state to store individual min values for each competency level
    const [competencyMinValues, setCompetencyMinValues] = useState<{[key: string]: string}>({});

    let logbookGroupTitleList: string[] = [];
    let yearOrSlotPrefix: string = '';

    if (logbookGroup?.title) {
        console.log(logbookGroup?.title)
        logbookGroupTitleList = logbookGroup?.title?.split(' -> ');
        yearOrSlotPrefix = logbookGroupTitleList[2] === 'core' ? 'Core' : 'Specialty';
    }

    const [createTargetSetup, { isSuccess, isLoading, isError, error }] = useCreateTargetSetupMutation();
    const  { data: entryMasterWiseTarget, isLoading: isLoadingEntryMasterWiseTarget } = useGetEntryMasterWiseTargetQuery(logbookEntrySetupMasterId);

    const competenceTitleOptions: SelectOption[] = logbookEntryFieldList?.data?.competency_group?.map((competence: any, index: number) => {
        return { label: competence.particulars, value: competence.id };
    });

    let competenceLevelOptions: SelectOption[] = [];
    let initialCompetenceLevelOptions: LookupData[] = useGetLookupDataQuery('competence_level').data?.data[0]?.childs!;

    const err: CustomError = error as CustomError;

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            // Remove min_value validation since we'll validate individual values
        }),

        onSubmit: (values) => {
            values.year = logbookGroupTitleList[2];

            // Validate that all selected competency levels have min values
            const hasEmptyValues = selectedCompetenceLevel.some((level: any) => 
                !competencyMinValues[level.value] || competencyMinValues[level.value].trim() === ''
            );

            if (hasEmptyValues) {
                toast.error('Please enter minimum values for all selected competency levels');
                return;
            }

            // Format the data as required - competency as array of objects
            const competency = selectedCompetenceLevel.map((level: any) => ({
                competency_level: level.value?.toString(),
                min_value: competencyMinValues[level.value]?.toString(),
            }));


            // Add other form data
            if (selectedCompetenceTitle?.value) {
                values.logbook_entry_setup_master_id = selectedCompetenceTitle?.value;
                const finalData = {
                    ...values,
                    competency: competency,
                };

                console.log('Final submission data:', finalData);

                createTargetSetup(finalData);
            } else {
                values.logbook_entry_setup_master_id = logbookEntrySetupMasterId;
                values.id = entryMasterWiseTarget?.data?.[0]?.id;
                const finalData = {
                    ...values,
                };

                console.log('Final submission data:', finalData);

                createTargetSetup(finalData);
            }

        },
    });

    const {
        handleSubmit,
        handleChange,
        getFieldProps,
        values,
        touched,
        errors,
        resetForm,
        setErrors,
        setFieldValue,
    } = formik;

    useEffect(() => {
        setCompetenceLevelTypeOptions([
            { label: '1', value: 1 },
            { label: '2', value: 2 },
            { label: '3', value: 3 },
            { label: '4', value: 4 },
        ]);
    }, []);

    useEffect(() => {
        if (isSuccess) {
            resetForm();
            setSelectedCompetenceTitle('');
            setSelectedCompetenceLevel([]);
            setCompetencyMinValues({});
            toast.success('Target Setup added successfully');
        }
        if (isError) {
            toast.error(err?.data?.message || err?.message || 'Something went wrong');
            setFromErrors(err.data, setErrors);
        }
    }, [isSuccess, isError]);

    // Handle competence level change
    const handleCompetenceLevelChange = (selectedOptions: any) => {
        setSelectedCompetenceLevel(selectedOptions || []);
        
        // Clean up min values for deselected levels
        const newMinValues = { ...competencyMinValues };
        const selectedValues = (selectedOptions || []).map((option: any) => option.value.toString());
        
        // Remove values for deselected levels
        Object.keys(newMinValues).forEach(key => {
            if (key !== 'default' && !selectedValues.includes(key)) {
                delete newMinValues[key];
            }
        });
        console.log(newMinValues)
        setCompetencyMinValues(newMinValues);
    };

    // Handle competence title change
    const handleCompetenceTitleChange = (selectedOption: any) => {
        setSelectedCompetenceTitle(selectedOption);
    };

    // Handle individual min value change for each competency level
    const handleMinValueChange = (levelValue: string, minValue: string) => {
        setCompetencyMinValues(prev => ({
            ...prev,
            [levelValue]: minValue
        }));
    };

    useEffect(() => {
        if(!isLoadingEntryMasterWiseTarget){
            setFieldValue('min_value', entryMasterWiseTarget?.data?.[0]?.min_value);
        }
    }, [isLoadingEntryMasterWiseTarget]);


    console.log(entryMasterWiseTarget)
    return (
        <>
            {isLoading ? (
                <div className="overlay">
                    <img src={loader} alt="Loading" height={100} width={300} />
                </div>
            ) : null}
            <Form
                className="custom-form"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}
                onReset={(e) => {
                    resetForm();
                    setSelectedCompetenceTitle('');
                    setSelectedCompetenceLevel([]);
                    setCompetencyMinValues({});
                }}
            >
                <div className="row">
                    {/* <div className="col-sm-12">
                        <FormGroup className="mb-3">
                            <div className="d-inline-block mx-2">
                                <div className="form-check form-check-left mb-3">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="target"
                                        id="overallTarget"
                                        value={"Overall Target"}
                                        onChange={(e) => {
                                            // Handle overall target logic
                                        }}
                                        disabled={readOnly}
                                    />
                                    <label className="form-check-label" htmlFor="overallTarget">Overall Target</label>
                                </div>
                            </div>

                            <div className="d-inline-block mx-2">
                                <div className="form-check form-check-left">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="target"
                                        id="competencyWiseTarget"
                                        value={"Competency Wise Target"}
                                        onChange={(e) => {
                                            // Handle competency wise target logic
                                        }}
                                        defaultChecked
                                        disabled={readOnly}
                                    />
                                    <label className="form-check-label" htmlFor="competencyWiseTarget">Competency Wise Target</label>
                                </div>
                            </div>
                        </FormGroup>
                    </div> */}

                    {competenceTitleOptions?.length > 0 ?
                        <>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="competence_title">Competence Title</Label>
                                    <Select
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedCompetenceTitle}
                                        onChange={handleCompetenceTitleChange}
                                        options={competenceTitleOptions}
                                        placeholder='Select...'
                                        name="competence_title"
                                        id="competence_title"
                                        isDisabled={readOnly}
                                    />
                                </FormGroup>
                            </div>

                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="competence_level">Competence Level</Label>
                                    <Select
                                        isMulti
                                        isClearable={true}
                                        isSearchable={true}
                                        value={selectedCompetenceLevel}
                                        onChange={handleCompetenceLevelChange}
                                        options={competenceLevelTypeOptions}
                                        placeholder='Select...'
                                        name="competence_level"
                                        id="competence_level"
                                        isDisabled={readOnly}
                                    />
                                </FormGroup>
                            </div>

                            {/* Dynamic min value inputs for each selected competency level */}
                            {selectedCompetenceLevel?.length > 0 && (
                                <div className="col-12">
                                    <div className="row">
                                        {selectedCompetenceLevel.map((level: any) => (
                                            <div key={level.value} className="col-lg-4 col-md-6 col-sm-12">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor={`min_value_${level.value}`}>
                                                        Minimum Value for Level {level.label}
                                                    </Label>
                                                    <InputField
                                                        type="number"
                                                        placeholder={`Enter minimum value for level ${level.label}`}
                                                        value={competencyMinValues[level.value] || ''}
                                                        onChange={(e: any) => handleMinValueChange(level.value.toString(), e.target.value)}
                                                        readOnly={readOnly}
                                                        name={`min_value_${level.value}`}
                                                        id={`min_value_${level.value}`}
                                                    />
                                                </FormGroup>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                        : 
                        // Show single min value input when no competency options available
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <FormGroup>
                                <Label htmlFor="min_value">Minimum to be Performed</Label>
                                <InputField
                                    type="number"
                                    placeholder="Enter minimum value"
                                    invalid={{ errors, touched }}
                                    {...getFieldProps('min_value')}
                                    readOnly={readOnly}
                                />
                            </FormGroup>
                        </div>
                    }

                    <div className="col-sm-12">
                        <div className="row justify-content-center">
                            <div className="col-sm-2">
                                <Button
                                    type="submit"
                                    color="secondary"
                                    text="Submit"
                                    className="me-2 mb-2"
                                ></Button>
                                <Button
                                    type="reset"
                                    color="warning"
                                    text="Reset"
                                    className="me-2 mb-2"
                                ></Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>

            {logbookEntrySetupMasterId &&
                logbookGroup &&
                submitStatus &&
                logbookEntrySetupMasterId !== '' && (
                    <CompetencyGroupTargetsList
                        id={logbookEntrySetupMasterId}
                        logbookGroup={logbookGroup}
                        logbookEntryFieldList={logbookEntryFieldList}
                        setSearch={setSearch}
                    />
                )}
        </>
    );
};

export default AddCompetencyGroupTargets;